import { isNil } from 'lodash'

import { createNoticeApi } from '@eastcoal/api/content/noticeOperation/createNotice'
import { queryNoticeApi } from '@eastcoal/api/content/noticeOperation/queryNotice'
import { updateNoticeApi } from '@eastcoal/api/content/noticeOperation/updateNotice'

import { PageContainer } from '@eastcoal/common/components/Layout/PageContainer'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'

import { CrudForm } from '@eastcoal/formily/components/CrudForm'
import { SubmitType } from '@eastcoal/formily/components/CrudForm/enums/SubmitType'
import { BackButton } from '@eastcoal/formily/components/CrudForm/shared/BackButton'
import { RefreshButton } from '@eastcoal/formily/components/CrudForm/shared/RefreshButton'
import { SaveButton } from '@eastcoal/formily/components/CrudForm/shared/SaveButton'
import { SubmitButton } from '@eastcoal/formily/components/CrudForm/shared/SubmitButton'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { RichEditor } from '@eastcoal/formily/components/RichEditor'
import { TextArea } from '@eastcoal/formily/components/TextArea'

import { useNavigate } from '@eastcoal/router/exports/react-router'

import { NoticeStatus } from '../enums/NoticeStatus'

import { NoticeFormExposedProps, NoticeFormProps } from './interface'

const schema: NoticeFormProps['schema'] = [
  {
    name: 'title',
    title: '标题',
    type: 'string',
    required: true,
    'x-decorator': FormItem,
    'x-component': Input
  },
  {
    name: 'description',
    title: '摘要',
    type: 'string',
    'x-decorator': FormItem,
    'x-decorator-props': {
      gridSpan: 2
    },
    'x-component': TextArea,
    'x-component-props': {
      maxLength: 300,
      showCount: true,
      placeholder: '请输入摘要，限300个字符以内'
    }
  },
  {
    name: 'content',
    title: '正文',
    type: 'string',
    required: true,
    'x-decorator': FormItem,
    'x-decorator-props': {
      gridSpan: 2
    },
    'x-component': RichEditor
  }
]

const readApi: NoticeFormProps['readApi'] = ({ id }) => {
  return {
    api: () => queryNoticeApi({ id }),
    ready: !isNil(id)
  }
}

const createApi: NoticeFormProps['createApi'] = (values, { submitType }) => {
  return createNoticeApi({
    ...values,
    status:
      submitType === SubmitType.SUBMIT
        ? NoticeStatus.PUBLISHED
        : NoticeStatus.DRAFT
  })
}

const updateApi: NoticeFormProps['updateApi'] = (values, { submitType }) => {
  return updateNoticeApi({
    ...values,
    status:
      submitType === SubmitType.SUBMIT
        ? NoticeStatus.PUBLISHED
        : NoticeStatus.DRAFT
  })
}

export const NoticeForm = ({ mode }: NoticeFormExposedProps) => {
  const navigate = useNavigate()
  const { message } = useFeedback()

  const handleSubmitSuccess = () => {
    message.success('操作成功')
    navigate(-1)
  }

  return (
    <PageContainer>
      <CrudForm
        createApi={createApi}
        grid={{ columns: 2 }}
        mode={mode}
        name='noticeForm'
        readApi={readApi}
        schema={schema}
        updateApi={updateApi}
        actions={[
          <BackButton key='backButton' />,
          <SaveButton key='saveButton' />,
          <SubmitButton key='publishButton'>发布</SubmitButton>,
          <RefreshButton key='refreshButton' />
        ]}
        onSuccess={handleSubmitSuccess}
      />
    </PageContainer>
  )
}
